import { render } from "./TermsGate.vue?vue&type=template&id=781d39bc&scoped=true"
import script from "./TermsGate.vue?vue&type=script&lang=js"
export * from "./TermsGate.vue?vue&type=script&lang=js"

import "./TermsGate.vue?vue&type=style&index=0&id=781d39bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781d39bc"]])

export default __exports__